



import React, { useState } from "react";

const gallery = [

  { id: 7, name: "", image: "images/Fleet/1.jpeg" },
  { id: 7, name: "", image: "images/Fleet/2.jpeg" },
  // { id: 7, name: "", image: "images/Fleet/3.jpeg" },
  { id: 7, name: "", image: "images/Fleet/4.jpeg" },
  { id: 7, name: "", image: "images/Fleet/5.jpeg" },
  { id: 7, name: "", image: "images/Fleet/6.jpeg" },
  { id: 7, name: "", image: "images/Fleet/7.jpeg" },
  { id: 7, name: "", image: "images/Fleet/8.jpeg" },
  { id: 7, name: "", image: "images/Fleet/9.jpeg" },
  { id: 7, name: "", image: "images/Fleet/10.jpeg" },
  { id: 7, name: "", image: "images/Fleet/11.jpeg" },
  { id: 7, name: "", image: "images/Fleet/12.jpeg" },
  { id: 7, name: "", image: "images/Fleet/13.jpeg" },




  { id: 7, name: "Swift Dzire", image: "images/Fleet/Dzire.jpg" },

 
 
  { id: 8, name: "Ertiga", image: "images/Fleet/ertiga.jpg" },
  { id: 8, name: "Innova", image: "images/Fleet/innova.jpg" },
  { id: 1, name: "Kia Carens", image: "images/Fleet/kia.jpg" },
  { id: 10, name: "Innova Crysta", image: "images/Fleet/innova-crysta.jpg" },
  { id: 10, name: "Rumion", image: "images/Fleet/rumion.jpg" },
  { id: 2, name: "Mini Bus", image: "images/Fleet/mini-bus.jpg" },
  { id: 3, name: "Tempo Traveller", image: "images/Fleet/tempo-traveller.jpg" },
  { id: 4, name: "Urbania", image: "images/Fleet/urbania.jpg" },
];

const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(null);

  const openImage = (index) => {
    setCurrentIndex(index);
  };

  const closeImage = () => {
    setCurrentIndex(null);
  };

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === gallery.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? gallery.length - 1 : prev - 1
    );
  };

  return (
    <>

    <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">Gallery</h1>
          </div>
        </div>
      </div>


     

      <div className="container py-5">
        <div className="row">
          {gallery.map((item, index) => (
            <div key={item.id} className="col-lg-4 col-md-6 mb-4">
              <div className="gallery-card borderr" onClick={() => openImage(index)}>
                <img src={item.image} alt={item.name} />
                <h5>{item.name}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* LIGHTBOX */}
      {currentIndex !== null && (
        <div className="lightbox">
          <span className="close darkcolorrrr" onClick={closeImage}>✖</span>

          <span className="prev" onClick={prevImage}>❮</span>
          <img
            src={gallery[currentIndex].image}
            alt="preview"
            className="lightbox-img "
          />
          <span className="next" onClick={nextImage}>❯</span>
        </div>
      )}
    </>
  );
};

export default Gallery;